import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from "react-helmet";
import AdminConsole from './components/Admin/AdminConsole';
import Show from './components/Show'
import Modal from 'react-modal';
import RequireAuth from './components/RequireAuth';
import { useState } from 'react';
import FeaturedShows from './components/FeaturedShows';
import Customization from './components/Customization';
import PasswordEntry from './components/PasswordEntry';

Modal.setAppElement('#root');

function App() {
  const [wallets, setWallets] = useState([]);

  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>Future Fest</title>
        </Helmet>
        <Routes>
          <Route path="/" element={ <PasswordEntry><FeaturedShows wallets={wallets} setWallets={setWallets} /></PasswordEntry> } />
          <Route path="/shows/:show_id" element={ <RequireAuth><Show wallets={wallets} setWallets={setWallets} /></RequireAuth> } />
          <Route path="/admin" element={ <RequireAuth role="Admin"><AdminConsole wallets={wallets} setWallets={setWallets} /></RequireAuth> } />
          <Route path="/customization" element={ <Customization wallets={() => {}} setWallets={() => {}} /> } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
